import { useMutation } from "@tanstack/react-query";
import { apiClient, type MatrixValidationResponse } from "../api";

export function useValidateEmailMatrix() {
  return useMutation({
    mutationFn: async (email: string): Promise<MatrixValidationResponse> => {
      const result = await apiClient.validateEmailMatrix(email);
      return result;
    },
  });
}
